import type { JourneyData } from "../types/journey.types";
import { ApiError } from "./ApiError";
import { getAuthHeaders } from "./api";

const API_BASE_URL =
    import.meta.env.VITE_API_BASE_URL || "https://stg-native-api.cleverpe.com/api";

/*
 * =========================================================
 * GATEWAY ADDRESS
 * =========================================================
 */

export interface AddressBlockPayload {
    city: string;
    state: string;
    fullAddress: string;
    area: string;
    ownershipType: "Owned" | "Rented" | "FamilyOwned";
}

export interface SubmitGatewayAddressRequest {
    address: AddressBlockPayload;
}

export interface SubmitGatewayAddressResponse {
    success: boolean;

    message: string;

    data: {
        journey: JourneyData;
    };
}

export const submitGatewayAddress = async (
    request: SubmitGatewayAddressRequest
): Promise<SubmitGatewayAddressResponse> => {

    const token =
        localStorage.getItem("journey_token");

    if (!token) {
        throw new ApiError(
            "Journey session expired.",
            401
        );
    }

    const response = await fetch(
        `${API_BASE_URL}/customer/add-address`,
        {
            method: "POST",

            headers: getAuthHeaders(),

            body: JSON.stringify(request),
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new ApiError(
            data?.message ||
            data?.data?.message ||
            "Unable to save address.",
            response.status,
            data
        );
    }

    return data;
};


export interface PreApprovalRequest {
    lender: string;
    flowType: string;
}

export async function fetchGatewayPreApproval(
    payload: PreApprovalRequest
) {
    const token =
        localStorage.getItem("journey_token");

    const response = await fetch(
        `${API_BASE_URL}/storeApproval/status`,
        {
            method: "POST",

            headers: {
                "Content-Type": "application/json",

                Authorization:
                    `Bearer ${token}`,
            },

            body: JSON.stringify(payload),
        }
    );

    const data =
        await response.json();

    if (!response.ok) {
        throw new Error(
            data.message ||
            "Unable to fetch pre-approval status."
        );
    }

    return data;
}